import {
  IonPage,
  IonList,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonToggle,
  IonContent,
} from '@ionic/react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../models';
import { useDebugStore } from '../models/DebugStore/DebugStore';
import { Area } from '../services/Database/CloudStorageService';

const DebugModal = observer(({ onDismiss }: { onDismiss: () => void }) => {
  const debugStore = useDebugStore();
  const rootStore = useStores();
  const { recordList } = rootStore;

  return (
    <IonPage className="notchSafe">
      <IonContent>
        <IonList>
          <IonItem>
            <IonLabel> Auth </IonLabel>
            <IonSelect
              value={debugStore.auth}
              placeholder="Auth"
              onIonChange={(e) => debugStore.setAuth(e.detail.value)}
            >
              <IonSelectOption value="Dummy">Dummy</IonSelectOption>
              <IonSelectOption value="Firebase">Firebase</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel> Storage </IonLabel>
            <IonSelect
              value={debugStore.storage}
              placeholder="Storage"
              onIonChange={(e) => debugStore.setStorage(e.detail.value)}
            >
              <IonSelectOption value="Dummy">Dummy</IonSelectOption>
              <IonSelectOption value="Firebase">Firebase</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel> FirebaseEmulator </IonLabel>
            <IonToggle
              checked={debugStore.useFirebaseEmulator}
              onIonChange={(e) =>
                debugStore.setUseFirebaseEmulator(e.detail.checked)
              }
            ></IonToggle>
          </IonItem>
          <IonItem>
            <IonLabel> Bluetooth </IonLabel>
            <IonSelect
              value={debugStore.bluetooth}
              placeholder="Bluetooth"
              onIonChange={(e) => debugStore.setBluetooth(e.detail.value)}
            >
              <IonSelectOption value="Dummy">Dummy</IonSelectOption>
              <IonSelectOption value="BLE">BLE</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel> Location </IonLabel>
            <IonSelect
              value={debugStore.location}
              placeholder="Location"
              onIonChange={(e) => debugStore.setLocation(e.detail.value)}
            >
              <IonSelectOption value="Dummy">Dummy</IonSelectOption>
              <IonSelectOption value="Smartphone">Smartphone</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel> Api </IonLabel>
            <IonSelect
              value={debugStore.api}
              placeholder="Api"
              onIonChange={(e) => debugStore.setApi(e.detail.value)}
            >
              <IonSelectOption value="Dummy">Dummy</IonSelectOption>
              <IonSelectOption value="Server">Server</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel> SearchTime (in seconds) </IonLabel>
            <IonSelect
              value={(debugStore.searchTime / 1000).toString()}
              placeholder="seconds"
              onIonChange={(e) =>
                debugStore.setSearchTime(parseInt(e.detail.value, 10))
              }
            >
              <IonSelectOption value="5">5</IonSelectOption>
              <IonSelectOption value="10">10</IonSelectOption>
              <IonSelectOption value="30">30</IonSelectOption>
              <IonSelectOption value="60">60</IonSelectOption>
            </IonSelect>
          </IonItem>

          <IonItem>
            <IonLabel> Trick Store </IonLabel>
            <IonSelect
              value={debugStore.trickStore}
              placeholder="TrickStore"
              onIonChange={(e) => debugStore.setRunStore(e.detail.value)}
            >
              <IonSelectOption value={Area.test}>Develop</IonSelectOption>
              <IonSelectOption value={Area.live}>Production</IonSelectOption>
            </IonSelect>
          </IonItem>
        </IonList>
        <IonButton fill="solid" color="danger" onClick={recordList.deleteAll}>
          Delete Own Tricks Data
        </IonButton>
        <IonButton
          fill="solid"
          color="danger"
          onClick={recordList.deleteAllFriendRuns}
        >
          Delete Friends Tricks Data
        </IonButton>
        <IonButton
          fill="solid"
          color="danger"
          onClick={recordList.deleteAllServerRuns}
        >
          Delete Server Tricks Data
        </IonButton>
        <IonButton
          fill="solid"
          color="danger"
          onClick={recordList.deleteUnanalyzedRuns}
        >
          Delete Unanalyzed Tricks
        </IonButton>
        <IonButton
          fill="solid"
          color="danger"
          onClick={rootStore.removeKnownFreak}
        >
          Delete known Freak
        </IonButton>
        <IonButton fill="solid" color="danger" onClick={rootStore.reset}>
          Reset Local Data
        </IonButton>
        <IonButton
          onClick={() => {
            window.location.reload();
            onDismiss();
          }}
        >
          Dismiss
        </IonButton>
      </IonContent>
    </IonPage>
  );
});

export default DebugModal;
